import React from 'react'
import {Redirect,Route} from 'react-router-dom'
import { Auth_login_Adm_Cliente } from '../utils'

const PrivateRouteAdmCliente = ({ component:Component,...rest})=>{
    return(
        <Route {...rest} render={ props =>(
            Auth_login_Adm_Cliente()?(<Component {...props}/>):
            <Redirect to ={{pathname:"/",state:{from:props.location}}}/>
        )}
        />
    )
}

export default PrivateRouteAdmCliente